import { isString } from "./types.js";
const MODULE = "bounty/mutex";
/**
 * TODO max-queue instead of discard
 * TODO wait for lock before reject when discarding
 *
 * @deprecated use SimpleQueue or DiscardingQueue
 *
 * @param {boolean=} discard
 * @param {boolean | string =} VERBOSE_DEBUG
 */
export const createMutex = (discard, VERBOSE_DEBUG) => {
    DEBUG: if (VERBOSE_DEBUG) {
        VERBOSE_DEBUG = isString(VERBOSE_DEBUG) ? `${MODULE} (${VERBOSE_DEBUG})` : MODULE;
    }
    /**
     * @internal
     * @type {Promise<any> | undefined}
     */
    let lock;
    /**
     * @template T
     * @param {() => Promise<T>} callback
     * @returns {Promise<T>}
     */
    const mutex = (callback) => {
        /**
         * @type {Promise<T>}
         */
        let result;
        if (lock) {
            if (discard) {
                DEBUG: if (VERBOSE_DEBUG) {
                    console.info(`${VERBOSE_DEBUG}: Discard callback because of lock.`, { callback, lock });
                }
                throw mutex;
            }
            DEBUG: if (VERBOSE_DEBUG) {
                console.debug(`${VERBOSE_DEBUG}: Defer callback because of lock.`, { callback, lock });
            }
            result = lock.then(callback, callback);
        }
        else {
            DEBUG: if (VERBOSE_DEBUG) {
                console.debug(`${VERBOSE_DEBUG}: Immediate callback.`, { callback });
            }
            result = callback();
        }
        lock = result;
        return result.finally(() => {
            if (lock === result) {
                DEBUG: if (VERBOSE_DEBUG) {
                    console.debug(`${VERBOSE_DEBUG}: Clear lock.`, { result });
                }
                lock = undefined;
            }
        });
    };
    return mutex;
};
